import Card from "components/card";
import InputField from "components/fields/InputField";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useUserAuth} from "../../../../context/UserAuthContext";
import axios from "axios";

const Password = () => {
    const [errorMessage, setErrorMessage] = useState("");
    let [password, setPassword] = useState("");
    let [confirmPassword, setConfirmPassword] = useState("");
    const navigate = useNavigate();

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const {
        logIn,
        userToken,
        userstate,
        user,
        accesscontrollevel,
        getEmailOtp,
        getMobileOtp,
        verifyEmailOtp,
        verifyMobileOtp,
        resetPassword,
        checkPasswords,
        createAccount,
        isValidEmailAddress,
        isValidPassword,
        isValidMobileNumber
    } = useUserAuth();

    function checkEmailExists(email) {
        var bodyFormData;
        bodyFormData = {
            email: email,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkEmail',
            data: bodyFormData
        }).then(async response => {
            //console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", email)

                    let otpResponse = await getEmailOtp(email)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "RP")
                        sessionStorage.setItem("password", password)
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }


        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    function checkMobileExists(mobileNumber) {
        var bodyFormData;
        bodyFormData = {
            mobile: mobileNumber,
            action: 2
        }
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkMobile',
            data: bodyFormData
        }).then(async response => {
            //console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", mobileNumber)

                    let otpResponse = await getMobileOtp(mobileNumber)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "RP")
                        sessionStorage.setItem("password", password)
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }

        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    const navigateToOtpScreen = async (e) => {
        //e.preventDefault()

        //setEmail(document.getElementById('email').value)
        let email = sessionStorage.getItem("email")

        //console.log(email)

        if (email.includes("@")) {
            if (isValidEmailAddress(email)) {
                checkEmailExists(email)
                //console.log("email: ", email + "is valid")
            } else {
                setErrorMessage("The email " + email + "  address is not as per format!!!")

            }
        } else {
            if (isValidMobileNumber(email)) {
                setErrorMessage("")
                checkMobileExists(email)
                //console.log("mobile: ", email + "is valid")
            } else {
                setErrorMessage("The mobile number " + email + " is not as per format!!!")

            }
        }
    }

    const handleChangePassword = async (e) => {
        e.preventDefault()
        let resetPasswordResponse;
        let email = sessionStorage.getItem("email")
        setErrorMessage("")
        password = document.getElementById('newPassword').value
        confirmPassword = document.getElementById('newConfirmPassword').value

        //console.log("P:", password)
        //console.log("CP:", confirmPassword)
        //console.log("E:", email)
        if (password !== confirmPassword) {
            setErrorMessage("The passwords do not match. Please try again.")
            //alert("The passwords do not match. Please try again.");
        } else {
            await navigateToOtpScreen()
        }
    }

    return (
        <Card extra={"w-full h-full p-3"}>
            {/* Header */}
            <div className="w-full px-2">
                <h4 className="text-xl font-bold text-navy-700 dark:text-white">
                    Change Password
                </h4>
                <p className="mt-1 text-base text-gray-600">
                    Here you can set your new password
                </p>
            </div>
            {/* inputs */}
            <div className="mt-9 grid grid-cols-1 gap-3">
                {/* <InputField
          label="Old Password"
          placeholder="Your Old Password"
          id="username"
          type="text"
        />*/}
                <InputField
                    label="New Password"
                    placeholder="Your New Password"
                    id="newPassword"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <InputField
                    label="New Password Confirmation"
                    placeholder="Confirm New Password"
                    id="newConfirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                />

                <div className="mt-2 flex w-full justify-end">
                    <button className="rounded-xl bg-[#004c86] px-8 py-2 text-base font-medium text-white transition duration-200
          hover:cursor-pointer hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86]
          dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86]"
                            onClick={handleChangePassword}>
                        Change Password
                    </button>
                </div>
            </div>
            <span className="errorMessage">
                {errorMessage}
            </span>
            {/* full width inputs */}
        </Card>
    );
};

export default Password;
